import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { OrderTracker } from '../../components/widgets/OrderTracker/OrderTracker';
import { OrderTrackerV1 } from '../../components/widgets/OrderTracker/OrderTrackerV1';
import { getOrderRunData, getOrderTrackData } from '../../store/map/actions';

const Tracker = (props) => {
  const { isNewUI } = props;
  if (isNewUI) return <OrderTrackerV1 {...props} />;
  else return <OrderTracker {...props} />;
};

export default withRouter(
  connect(
    (state, ownProps) => {
      const { orderId, showAddress, setShowMap, showMap, setShowAddress } =
        ownProps;
      const { mapState, ordersState } = state;
      const { mapData, orderRunData } = mapState;
      const { isNewUI } = ordersState;
      if (!mapData || !orderRunData) return;

      const orderRunInfo =
        orderId && orderRunData && orderRunData[orderId]
          ? orderRunData[orderId]
          : null;
      const orderTrackInfo =
        orderId && mapData && mapData[orderId] ? mapData[orderId] : null;
      return {
        isNewUI,
        orderId,
        orderTrackInfo,
        orderRunInfo,
        showAddress,
        setShowMap,
        showMap,
        setShowAddress,
      };
    },
    (dispatch) => {
      return {
        getOrderTrackData: (data) => dispatch(getOrderTrackData(data)),
        getOrderRunData: (data) => dispatch(getOrderRunData(data)),
      };
    },
  )(Tracker),
);
